import Api from "~/service/Api";

class UiMeet3dLinkRepository {
  fetch(locale, query) {
    return Api.get(`/${locale}/ui-meet-3d/links`, query);
  }
}

export default UiMeet3dLinkRepository;
